module.exports = __webpack_public_path__ + "img/xbsys2.0490a53f.png";